<template>
  <f7-page @page:beforein="beforein">
    <navbar :text="`${currentPlantation.company} > ${currentPlantation.explotation} > ${currentPlantation.parcel} > ${currentPlantation.sector} > ${currentPlantation.name} > ${$t('Searcher.observations.observations_title')} > ${$t('Searcher.observations.add_observation_title')}`" />
    <PopupConfirmedDate
      v-if="showPopupConfirmedDate"
      :disabled-save-button="disabledSaveButton"
      @close="closePopupConfirmedDate"
      @save="savePopupConfirmedDate"
    />
    <PopupConfirmObservationExit />
    <f7-row no-gap>
      <f7-col>
        <f7-row>
          <f7-col>
            <MainData
              :company-id="currentPlantation.companyId"
              :plantation-id="currentPlantation.id"
              :scouting-points="scoutingPoints"
              :categories-of-templates="categoriesOfTemplates"
              :laboratories-of-templates="laboratoriesOfTemplates"
              :templates-by-category="templatesByCategory"
              :templates-by-laboratory="templatesByLaboratory"
              :current-values-main-data="currentValuesMainData"
            />
          </f7-col>
        </f7-row>
        <f7-row>
          <f7-col><MultimediaData :multimedia="multimedia" /></f7-col>
        </f7-row>
      </f7-col>
      <f7-col>
        <div v-if="!loadedGIS || !showGIS">
          <div class="loadingFalse">
            <div
              v-if="!loadedGIS"
              class="preloader"
            />
          </div>
        </div>
        <div v-else>
          <GISPointsMap
            v-if="currentScoutingPoint.type === 'POINT'"
            :zoom="zoom"
            :name-map="mainMap1"
            :tree-locations="treeLocations"
            :current-point="{latitude: currentScoutingPoint.latitude, longitude: currentScoutingPoint.longitude}"
            :only-read="true"
            :selected-min-height="'395px'"
            :includes-content-devx="true"
            :show-home-btn="true"
          />
          <GISGeoJsonMap
            v-else
            :zoom="zoom"
            :selected-min-height="'395px'"
            :name-map="mainMap2"
            :tree-locations="treeLocations"
          />
        </div>
      </f7-col>
    </f7-row>
    <f7-row>
      <f7-col>
        <TemplateData
          v-if="showTemplateForm"
          :template-form="templateForm"
        />
      </f7-col>
    </f7-row>
    <div
      class="footer"
    >
      <f7-row>
        <f7-col width="30">
          <f7-button
            class="dx-btn-cancel btnBack margin-left"
            type="default"
            text-color="grey"
            styling-mode="outlined"
            name="ButtonCancel"
            style="margin-bottom: 10px"
            @click="goToObservations"
          >
            {{ $t('Go_Back') }}
          </f7-button>
        </f7-col>
        <f7-col width="40" />
        <f7-col
          width="30"
          class="justify-content-end"
        >
          <f7-button
            class="dx-btn-save margin-right btn-width-100"
            raised
            type="success"
            styling-mode="outlined"
            name="ButtonSave"
            @click="callToCreateObservation"
          >
            {{ $t('Button_save_text') }}
          </f7-button>
        </f7-col>
      </f7-row>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import navbar from '../../../components/NavBar.vue';
import { generateRandomId } from '../../../js/utils/generateRamdonId'
import MainData from '../../../components/searcher/observations/observationForm/mainData/index.vue';
import MultimediaData from '../../../components/searcher/observations/observationForm/multimediaData/index.vue';
import TemplateData from '../../../components/searcher/observations/observationForm/templateData/index.vue';
import GISPointsMap from '../../../components/Gis/GISPointsMap/index.vue';
import GISGeoJsonMap from '../../../components/Gis/GISGeoJsonMap/index.vue';
import PopupConfirmedDate from './popupConfirmedDate.vue';
import PopupConfirmObservationExit from '../../../components/searcher/observations/popupConfirmObservationExit/index.vue';

export default {
  name: 'CreateObservation',
  components: {
    navbar,
    MainData,
    MultimediaData,
    TemplateData,
    GISPointsMap,
    GISGeoJsonMap,
    PopupConfirmedDate,
    PopupConfirmObservationExit
  },
  data() {
    return {
      zoom: 20,
      mainMap1: 'createObservationPoint',
      mainMap2: 'createObservationParcel',
      loadedGIS: false,
      disabledSaveButton: false,
    };
  },
  computed: {
    showGIS() {
      return this.currentScoutingPoint !== null;
    },
    ...mapState('SearcherObservations', ['currentScoutingPoint', 'templateForm', 'showTemplateForm', 'categoriesOfTemplates', 'laboratoriesOfTemplates',  'scoutingPoints', 'templatesByCategory', 'templatesByLaboratory', 'multimedia', 'idGeolocationPoint', 'category', 'subcategory', 'laboratory', 'analysis_type', 'templateValue', 'date', 'confirmedDate', 'showPopupConfirmedDate']),
    ...mapState('Plantation', ['currentPlantation', 'treeLocations']),
    ...mapState('Observations', ['routeToGo']),
    ...mapGetters('SearcherObservations', ['currentValuesMainData']),
  },
  methods: {
    async beforein() {
      this.$f7.preloader.show();
      try {
        this.initStore();
        this.setShowTemplateForm(false);
        await this.getScoutingPoints(this.currentPlantation);
        await this.getCategoriesOfTemplates();
        await this.getLaboratoriesOfTemplates();
        this.setEdit(false);
        this.resetCurrentPoint();
        await this.fetchLocationsByPlantation();
        this.loadedGIS = true;
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(`${error}`),
            width: 550,
          },
          'error',
          3000,
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    goToObservations() {
      if (this.category === 'Muestreo') {
      this.setDisplayConfirmExitPopup(true);
    } else {
      this.setDisplayConfirmExitPopup(false);
      this.setRouteToGo('/searcher/observations/');
      this.setTabToGo('observations');
      this.$f7.views.main.router.navigate(this.routeToGo, { reloadCurrent: true });
    }
    },
    async callToCreateObservation() {
      if (!this.confirmedDate) {
        const actualDate = moment(this.date, 'YYYY-MM-DD');
        const initDate = moment(this.currentPlantation.initDate, 'YYYY-MM-DD');
        const endDate = moment(this.currentPlantation.endDate, 'YYYY-MM-DD');

        if (!actualDate.isBetween(initDate, endDate, 'days', '[]')) {
          this.setShowPopupConfirmedDate(true);
          this.disabledSaveButton = false;
          return;
        }
      }

      const showNotification = (messageKey) => {
        this.disabledSaveButton = false;
        this.$notifyDX(
          {
            message: this.$t(`Searcher.observations.${messageKey}`),
            width: 550,
          },
          'info',
          3000,
        );
      };

      if (this.category === '') {
        showNotification('categoryValidation');
        return;
      }

      if (this.idGeolocationPoint === '' && this.category !== 'Recetario') {
        showNotification('geolocationValidation');
        return;
      }

      if (this.subcategory === '' && !['Muestreo', 'Recetario'].includes(this.category)) {
        showNotification('subcategoryValidation');
        return;
      }

      if (this.laboratory === '' && ['Muestreo'].includes(this.category)) {
        showNotification('laboratoryValidation');
        return;
      }

      if (this.analysis_type === '' && ['Muestreo'].includes(this.category)) {
        showNotification('analysisValidation');
        return;
      }

      // EDSER-2118: selecting analysis_type only starts loading the template
      // (which is what generates sample_id) - it doesn't mean it's ready yet.
      // showTemplateForm only turns true once formattingTemplate has finished,
      // so wait for it instead of racing the async template load.
      if (!this.showTemplateForm && ['Muestreo'].includes(this.category)) {
        showNotification('templateLoadingValidation');
        return;
      }

      let formFilledEntirely = true;

      const BreakException = {};
      try {
        this.templateForm.forEach((element) => {
          if (element.required) {
            if (!Object.prototype.hasOwnProperty.call(this.templateValue, element.field)) {
              formFilledEntirely = false;
              throw BreakException;
            }
          }
        });
      } catch (e) {
        this.disabledSaveButton = false;
        if (e !== BreakException) throw e;
      }

      if (formFilledEntirely === false) {
        this.disabledSaveButton = false;
        this.$notifyDX(
          {
            message: this.$t('Searcher.observations.fillFormValidation'),
            width: 550,
          },
          'info',
          3000,
        );
        return;
      }

      let error = null;
      let messageError = '';
      this.$f7.preloader.show();

      try {
        await this.createObservation(this.currentPlantation);
      } catch (err) {
        this.disabledSaveButton = false;
        error = err; 
        messageError = err;
        if (err === 'multimedia') {
          this.$notifyDX(
            {
              message: this.$t('multimediaFileError'),
              width: 550,
            },
            'error',
            3000,
          );
          // Devuelve el error de que el id ya esta repetido
        } else if (err.code === '406') {
          // Generamos otro id distinto
          const newSampleId = generateRandomId(7);
          // Guardamos en la store en el sample_id
          this.setSampleId(newSampleId);
          this.$notifyDX(
            {
              message: this.$t('sampleIdDuplicate'),
              width: 550,
            },
            'error',
            3000,
          );
        } else {
          this.$notifyDX(
            {
              message: this.$t(`${err}`),
              width: 550,
            },
            'error',
            3000,
          );
        }
      } finally {
        this.$f7.preloader.hide();

        if (messageError !== 'multimedia' && error?.code !== '406') {
          this.$f7.views.main.router.navigate('/searcher/observations/', { reloadCurrent: true });
        }
      }
    },
    closePopupConfirmedDate() {
      this.disabledSaveButton = false;
      this.setShowPopupConfirmedDate(false);
    },
    async savePopupConfirmedDate() {
      this.disabledSaveButton = true;
      this.setConfirmedDate(true);
      await this.callToCreateObservation();
    },
    ...mapActions('SearcherObservations', ['initStore', 'getScoutingPoints', 'getCategoriesOfTemplates', 'getLaboratoriesOfTemplates', 'createObservation', 'setEdit', 'setShowTemplateForm', 'setShowPopupConfirmedDate', 'setConfirmedDate', 'setSampleId']),
    ...mapActions('Gis', ['resetCurrentPoint']),
    ...mapActions('Plantation', ['fetchLocationsByPlantation']),
    ...mapActions('Observations', ['setDisplayConfirmExitPopup', 'setRouteToGo']),
    ...mapActions('Utilities', ['setTabToGo'])
  },
};
</script>

<style scoped>
.dx-btn-save{
    background: #0071BD;
    color: #ffffff;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
    height: auto;
    line-height: 3;
    box-shadow: none;
  }
  .dx-btn-save:hover {
    box-shadow: 0px 2px 1px rgba(0,0,0,0.07);
  }
  .dx-btn-back{
    background: #FFFFFF;
    color: #74838C;
    border: 1px solid #74838C;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
    height: auto;
    line-height: 3;
    box-shadow: none;
  }
  .dx-btn-back:hover {
    box-shadow: 0px 2px 1px rgba(0,0,0,0.07);
  }
  .footer{
      margin-top: 10px;
  }
</style>
